<form class="container-fluid" [formGroup]="formGroup()">
    <div class="row">
        <div class="col-md-3">
            <sl-input type="email" placeholderKey="Contact.Email" [control]="formGroup().controls['email']" />
        </div>
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="Contact.FirstName" [control]="formGroup().controls['firstName']" />
        </div>
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="Contact.LastName" [control]="formGroup().controls['lastName']" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="Shareholders.EmployeeNumber" [control]="formGroup().controls['employeeNumber']" />
        </div>
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="User.Function" [control]="formGroup().controls['function']" />
        </div>
        <div class="col-md-3">
            <sl-auto-complete
                placeholderKey="General.Language"
                [control]="formGroup().controls['languageId']"
                [observable]="metaResource.getLanguages()" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="User.PhoneNumber" [control]="formGroup().controls['phone']" />
        </div>
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="Contact.MobileNumber" [control]="formGroup().controls['mobilePhoneNumber']" />
        </div>
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="User.WindowsUser" [control]="formGroup().controls['windowsUser']" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <sl-input type="text" placeholderKey="User.Username" [control]="formGroup().controls['username']" />
        </div>
        <div class="col-md-3">
            <mat-checkbox [formControl]="formGroup().controls['getsNotified'] | formControl">
                {{ 'User.GetsNotified' | translate }}
            </mat-checkbox>
        </div>
        <div class="col-md-3">
            <mat-checkbox [formControl]="formGroup().controls['approvalRight'] | formControl">
                {{ 'User.ApprovalRight' | translate }}
            </mat-checkbox>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <sl-auto-complete placeholderKey="Login.Role" [control]="formGroup().controls['roleId']" [observable]="roles" />
        </div>
    </div>
</form>
